import {
  BarChart3,
  BookOpen, Crown, FileText,
  Play,
  QrCode,
  ShoppingCart, Star, Trophy,
  Video, Zap
} from "lucide-react";

export const features = [
  {
    icon: BookOpen,
    title: "حصص تفاعلية",
    description: "اتفرج على حصص فيديو مرتبة حسب السنين الدراسية والمجموعات",
    badge: "مناسب للثانوي",
    color: "bg-blue-100 text-blue-600",
  },
  {
    icon: Video,
    title: "حصص لايف",
    description:
      "احضر حصص لايف وقت ما بتتعمل، وتفاعل واسأل مدرسك كأنك قاعد قدامه",
    badge: "مباشر ولحظي",
    color: "bg-green-100 text-green-600",
  },
  {
    icon: Play,
    title: "حصص فيديو",
    description: "شوف حصص فيديو بجودة عالية وتحكم في التشغيل براحتك و بسهولة",
    badge: "جودة عالية",
    color: "bg-purple-100 text-purple-600",
  },
  {
    icon: Trophy,
    title: "اختبارات وواجبات",
    description: "جرب نفسك بامتحانات وواجبات عليها وقت وتصحيحها بيكون فوري",
    badge: "تصحيح تلقائي",
    color: "bg-orange-100 text-orange-600",
  },
  {
    icon: FileText,
    title: "ملفات و صور",
    description: "حمّل الملازم و الصور والملفات الإضافية عشان تذاكر من غير نت",
    badge: "تقدر تحمّلها",
    color: "bg-indigo-100 text-primary",
  },
  {
    icon: QrCode,
    title: "هوية الطالب الرقمية",
    description:
      "لكل طالب كود QR خاص بيه عشان إثبات الهوية والدخول الآمن للمنصة",
    badge: "دخول آمن",
    color: "bg-red-100 text-red-600",
  },
  {
    icon: ShoppingCart,
    title: "تتبع المشتريات",
    description:
      "اعرف إيه اللي اشتريته وتابع حالة الدفع وكمان هتلاقي كل حاجة متسجلة",
    badge: "سجل المدفوعات",
    color: "bg-yellow-100 text-yellow-600",
  },
  {
    icon: BarChart3,
    title: "تقارير وتحليلات",
    description: "تابع مستواك ودرجاتك لحظة بلحظة واعرف إنت وصلت لفين",
    badge: "تحليلات مفصلة",
    color: "bg-teal-100 text-teal-600",
  },
];

export const plans = [
  {
    key: "free",
    title: "الباقة المجانية",
    price: "مجاناً للأبد",
    popular: false,
    icon: <Star className="size-10" />,
    features: {
      "منصة خاصة بإسمك": true,
      "نشر الحصص المسجلة": true,
      "50 كود شهريًا مجانًا ثم 5 جنيه للكود": true,
      "عدد غير محدود من الطلاب و الحصص": true,
      "متطلبات شراء الحصص": false,
      "اختبارات وامتحانات تلقائية التصحيح": false,
      "رفع ملفات مع الحصة": false,
      "تقارير وتحليلات للطلاب": false,
      "إرسال تقارير لأولياء الأمور عبر واتساب": false,
      "نظام الحضور وتتبع الطلاب": false,
      "حصص مباشرة مع الطلاب": false,
      "إنشاء مدرسين مساعدين و تحديد صلاحياتهم": false,
      // "إرسال الأسئلة أثناء الحصص المباشرة": false,
      // "مشاركة ملف PDF اثناء الحصص المباشرة": false,
      // "مشاركة الشاشة او فتح الكاميرا اثناء الحصص المباشرة": false,
    },
    buttonText: "إشترك مجاناً",
    subscribedBtnText: "أنت مشترك بالفعل",
    buttonClass: "btn-outline-primary text-ea-primary",
  },
  {
    key: "basic",
    title: "الباقة المتقدمة",
    price: "300 جنيه شهريًا",
    popular: false,
    icon: <Zap className="size-10" />,
    features: {
      "منصة خاصة بإسمك": true,
      "نشر الحصص المسجلة": true,
      "50 كود شهريًا مجانًا ثم 5 جنيه للكود": true,
      "عدد غير محدود من الطلاب و الحصص": true,
      "متطلبات شراء الحصص": true,
      "اختبارات وامتحانات تلقائية التصحيح": true,
      "رفع ملفات مع الحصة": true,
      "تقارير وتحليلات للطلاب": true,
      "إرسال تقارير لأولياء الأمور عبر واتساب": true,
      "نظام الحضور وتتبع الطلاب": true,
      "حصص مباشرة مع الطلاب": false,
      "إنشاء مدرسين مساعدين و تحديد صلاحياتهم": false,
      // "إرسال الأسئلة أثناء الحصص المباشرة": false,
      // "مشاركة ملف PDF اثناء الحصص المباشرة": false,
      // "مشاركة الشاشة او فتح الكاميرا اثناء الحصص المباشرة": false,
    },
    buttonText: "إشترك الآن",
    subscribedBtnText: "أنت مشترك بالفعل",
    buttonClass: "ea-btn",
  },
  {
    key: "pro",
    title: "الباقة الاحترافية",
    price: "500 جنيه شهريًا",
    popular: true,
    icon: <Crown className="size-10" />,
    features: {
      "منصة خاصة بإسمك": true,
      "نشر الحصص المسجلة": true,
      "50 كود شهريًا مجانًا ثم 5 جنيه للكود": true,
      "عدد غير محدود من الطلاب و الحصص": true,
      "متطلبات شراء الحصص": true,
      "اختبارات وامتحانات تلقائية التصحيح": true,
      "رفع ملفات مع الحصة": true,
      "تقارير وتحليلات للطلاب": true,
      "إرسال تقارير لأولياء الأمور عبر واتساب": true,
      "نظام الحضور وتتبع الطلاب": true,
      "حصص مباشرة مع الطلاب": true,
      "إنشاء مدرسين مساعدين و تحديد صلاحياتهم": true,
      // "إرسال الأسئلة أثناء الحصص المباشرة": true,
      // "مشاركة ملف PDF اثناء الحصص المباشرة": true,
      // "مشاركة الشاشة او فتح الكاميرا اثناء الحصص المباشرة": true,
    },
    buttonText: "إشترك الآن",
    subscribedBtnText: "أنت مشترك بالفعل",
    buttonClass: "btn-dark",
  },
];

export const faq = [
  {
    question: "ما هي منصة كشكول؟",
    answer:
      "كشكول هي منصة تعليمية تتيح للمعلمين إنشاء منصتهم الخاصة تحت اسمهم، حيث يمكنهم تقديم حصص مباشرة ومسجلة، وإجراء اختبارات، وتتبع تقدم الطلاب بسهولة.",
  },
  {
    question: "هل يمكنني استخدام المنصة مجانًا؟",
    answer:
      "نعم! يمكنك استخدام كشكول مجانًا لنشر الحصص المسجلة والحصول على 50 كود مجاني شهريًا.",
  },
  {
    question: "ما الفرق بين الباقات المتاحة؟",
    answer:
      "الباقة المجانية تتيح نشر الحصص المسجلة فقط، بينما الباقة المتقدمة توفر جميع الميزات بسعر 300 جنيه شهريًا، والباقة الاحترافية تقدم نفس الميزات مع 200 كود شهريًا بسعر 500 جنيه.",
  },
  {
    question: "كيف يتم بيع الحصص للطلاب؟",
    answer:
      "يقوم المدرس بإرسال أكواد فتح الحصص للطلاب، و يستخدم الطلاب الاكواد لشراء الحصة.",
  },
  {
    question: "كيف يستخدم الطلاب منصتي؟",
    answer:
      "بعد ان يقوم الطالب بإنشاء حساب من الصفحة الرئيسية، يمكنه الدخول علي جميع اقسام المنصة و معرفة الحصص المتاحة، ثم يقوم بشراء الحصص عن طريق أكواد شراء الحصص",
  },
  {
    question: "ما تكلفة الأكواد الإضافية؟",
    answer: "كل كود إضافي بعد الرصيد الأساسي يكلف 5 جنيه لكل كود.",
  },
  {
    question: "هل يمكن للآباء تتبع تقدم أبنائهم؟",
    answer:
      "نعم! يمكنك إرسال تقارير الأداء والحضور للآباء عبر واتساب لإبقائهم على اطلاع دائم.",
  },
  {
    question: "هل يوجد نظام تتبع للحضور؟",
    answer:
      "نعم، يمكن للمعلمين متابعة حضور وغياب الطلاب من خلال تقارير الحضور في لوحة تحكم المدرس.",
  },
  {
    question: "كيف أبدأ في استخدام كشكول؟",
    answer:
      "يمكنك التسجيل مجانًا خلال دقائق والحصول على منصتك الخاصة مباشرةً من خلال موقعنا، يحصل المدرس على منصة خاصة بعنوان مشابه لهذا الرابط (mr-ahmed.qashqool.com).",
  },
];
